import { render } from "./AppNavigationFavoritesItem.vue?vue&type=template&id=48b6fe86&scoped=true"
import script from "./AppNavigationFavoritesItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationFavoritesItem.vue?vue&type=script&lang=js"

import "./AppNavigationFavoritesItem.vue?vue&type=style&index=0&id=48b6fe86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b6fe86"]])

export default __exports__